import React from "react";
import "twin.macro";
import { graphql } from "gatsby";
import { PageLayout, CTA } from "../components";

const ContactLenses = ({ data: { strapiDsrTerms } }) => {
  return (
    <PageLayout {...strapiDsrTerms} flourish={1}>
      <CTA />
    </PageLayout>
  );
};

export default ContactLenses;

export const query = graphql`
  query termsPageQuery {
    strapiDsrTerms {
      content
      title
    }
  }
`;
